import { IoAlertCircleOutline } from 'react-icons/io5';

import { formatOutOfWaterUntil } from './formatOutOfWaterUntil';
import styles from './OutOfWaterBadge.module.scss';

interface OutOfWaterBadgeProps {
  align?: 'left' | 'center' | 'right';
  variant?: 'warning' | 'dark';
  size?: 'small' | 'medium';
  until?: string | Date | null;
}

const alignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
} as const;

const colorMap = {
  warning: 'var(--color-warning)',
  dark: 'var(--text-primary)',
} as const;

const OutOfWaterBadge = ({
  align = 'center',
  variant = 'warning',
  size = 'medium',
  until,
}: OutOfWaterBadgeProps) => {
  const justifyContent = alignmentMap[align];
  const color = colorMap[variant];
  const sizeClass = size === 'small' ? styles.small : '';
  const untilLabel = formatOutOfWaterUntil(until);

  return (
    <p className={`${styles.badge} ${sizeClass}`} style={{ justifyContent, color }}>
      <IoAlertCircleOutline />
      <span className={styles.text}>
        {untilLabel ? `Out of water until ${untilLabel}` : 'Out of Water'}
      </span>
    </p>
  );
};

export default OutOfWaterBadge;
